import "styles/main.scss";
import { createRoot } from "react-dom/client";
import { Provider } from 'react-redux';
import store from "store/store";
import App from './App';

const Root: React.FC = () => {
  return (
    <Provider store={store}>
      <App/>
    </Provider>
  );
};

const root = createRoot(document.getElementById("root")!);
root.render(<Root />);